export const createPathFinderHTML = () => {
  const container = document.createElement('div');
  container.id = 'pf-mesh';
  container.className = 'pf-mesh-wrapper';

  const header = document.createElement('div');
  header.className = 'pf-mesh-header';
  header.innerHTML = '';

  const content = document.createElement('div');
  content.className = 'pf-mesh-content';

  const description = document.createElement('div');
  description.className = 'pf-mesh-content-description';
  description.innerHTML = '';

  const stepCount = document.createElement('div');
  stepCount.className = 'pf-mesh-content-step-count';
  stepCount.innerHTML = '';

  const footer = document.createElement('div');
  footer.className = 'pf-mesh-footer';

  const buttonBack = document.createElement('button');
  buttonBack.className = 'pf-mesh-button pf-mesh-button--back';
  buttonBack.innerHTML = 'PREVIOUS';

  const buttonNext = document.createElement('button');
  buttonNext.className = 'pf-mesh-button pf-mesh-button--next';
  buttonNext.innerHTML = 'NEXT';

  content.appendChild(description);
  content.appendChild(stepCount);

  footer.appendChild(buttonBack);
  footer.appendChild(buttonNext);

  container.appendChild(header);
  container.appendChild(content);
  container.appendChild(footer);
  document.body.appendChild(container);
  return {
    html: container,
    refs: { header, description, stepCount, footer, buttonBack, buttonNext },
  };
};
